module.exports = __webpack_public_path__ + "static/media/cogwheel.fc275bef.png";